<template>
  <section class="bloc-text-media-portrait">

    <AnimatedPath :number="2"/>

    <div class="bloc-text-media-portrait__wrapper">
      <div class="bloc-text-media-portrait__background"></div>

      <h2 class="bloc-text-media-portrait__title scroll-step js-scroll-show" v-html="content.title"></h2>

       <div class="bloc-text-media-portrait__media-ctn scroll-step js-scroll-show">
        <img v-if="content.img" :src="require(`@/${content.img}`)">
        <PlayerAutoVideoEmbed v-else-if="content.video && !content.video.video_provider" :content="content.video" />
        <PlayerAutoExternalEmbed v-else-if="content.video && content.video.video_provider" :content="content.video" :forcePortrait="true" />
      </div>

      <p class="bloc-text-media-portrait__text_emphase scroll-step js-scroll-show" v-html="content.text_emphase"></p>
    </div>
  </section>
</template>

<script>
import AnimatedPath from '@/components/AnimatedPath.vue'
import PlayerAutoVideoEmbed from '@/components/PlayerAutoVideoEmbed.vue'
import PlayerAutoExternalEmbed from '@/components/PlayerAutoExternalEmbed.vue'

export default {
  name: 'TextMediaPortrait',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  components: {
    AnimatedPath,
    PlayerAutoVideoEmbed,
    PlayerAutoExternalEmbed
  }
}
</script>

<style lang="scss">
  .bloc-text-media-portrait {
    width: 100vw;
    background: $th-white;
    padding: rem(60) 0 rem(80);
    overflow: hidden;
    position: relative;

    .animated-path {
      height: calc(100% + 10px) !important;
      position: absolute;
      top: -5px;

      @include media($from: small) {
        right: 0;
      }
    }

    &__wrapper {
      width: grid_m(5, 4);
      margin: 0 auto;

      @include media($from: small) {
        width: 100%;
      }
    }

    &__background {
      background: $th-cherry;
      width: 100%;
      height: grid_m(3.5, 3);
      position: absolute;
      left: 0;
      top: 0;

      @include media($from: small) {
        height: grid(4.5, 3);
      }
    }

    &__media-ctn {
      width: grid_m(3, 2);
      height: grid_m(5, 4);
      display: block;
      position: relative;
      margin: 0 auto;
      margin-top: rem(30);

      @include media($from: small) {
        width: grid(4, 3);
        height: grid(7, 6);
        margin-top: rem(70);
        margin-bottom: rem(30);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__title {
      @include paragraph($type: 'extrabig-krug-hand', $color: $th-yellow, $uppercase: false);
      position: relative;
      text-align: center;
      display: block;
      font-style: italic;
    }

    &__text_emphase {
      @include paragraph($type: 'big-gotham', $color: $th-cherry, $uppercase: true);
      position: relative;
      text-align: center;
      display: block;
      margin-top: rem(50);

      @include media($from: small) {
        width: grid(7, 6);
        margin: 0 auto;
        margin-top: rem(80);
      }


      strong {
         @include paragraph($type: 'big-gotham-medium', $color: $th-cherry, $uppercase: true);
      }
    }
  }
</style>
